// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/settings.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/settings.proto.
 */
export const file_catpocs_v1_settings: GenFile = /*@__PURE__*/
  fileDesc("ChljYXRwb2NzL3YxL3NldHRpbmdzLnByb3RvEgpjYXRwb2NzLnYxItMBChROb3RpZmljYXRpb25TZXR0aW5ncxIPCgdlbmFibGVkGAEgASgIEhgKEG5vdGlmeV9vbl9kZXBsb3kYAiABKAgSGQoRbm90aWZ5X29uX2ZhaWx1cmUYAyABKAgSFgoObm90aWZ5X29uX3N5bmMYBCABKAgSFQoNd2ViZXhfcm9vbV9pZBgFIAEoCRIVCg13ZWJleF9lbmFibGVkGAYgASgIEhgKEGVtYWlsX3JlY2lwaWVudHMYByABKAkSFQoNZW1haWxfZW5hYmxlZBgIIAEoCCJzCghTZXR0aW5ncxI3Cg1ub3RpZmljYXRpb25zGAEgASgLMiAuY2F0cG9jcy52MS5Ob3RpZmljYXRpb25TZXR0aW5ncxIuCgp1cGRhdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIUChJHZXRTZXR0aW5nc1JlcXVlc3QiPQoTR2V0U2V0dGluZ3NSZXNwb25zZRImCghzZXR0aW5ncxgBIAEoCzIULmNhdHBvY3MudjEuU2V0dGluZ3MiUAoVVXBkYXRlU2V0dGluZ3NSZXF1ZXN0EjcKDW5vdGlmaWNhdGlvbnMYASABKAsyIC5jYXRwb2NzLnYxLk5vdGlmaWNhdGlvblNldHRpbmdzIkAKFlVwZGF0ZVNldHRpbmdzUmVzcG9uc2USJgoIc2V0dGluZ3MYASABKAsyFC5jYXRwb2NzLnYxLlNldHRpbmdzIisKGFRlc3ROb3RpZmljYXRpb25zUmVxdWVzdBIPCgdjaGFubmVsGAEgASgJIj0KGVRlc3ROb3RpZmljYXRpb25zUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJMpwCCg9TZXR0aW5nc1NlcnZpY2USTgoLR2V0U2V0dGluZ3MSHi5jYXRwb2NzLnYxLkdldFNldHRpbmdzUmVxdWVzdBofLmNhdHBvY3MudjEuR2V0U2V0dGluZ3NSZXNwb25zZRJXCg5VcGRhdGVTZXR0aW5ncxIhLmNhdHBvY3MudjEuVXBkYXRlU2V0dGluZ3NSZXF1ZXN0GiIuY2F0cG9jcy52MS5VcGRhdGVTZXR0aW5nc1Jlc3BvbnNlEmAKEVRlc3ROb3RpZmljYXRpb25zEiQuY2F0cG9jcy52MS5UZXN0Tm90aWZpY2F0aW9uc1JlcXVlc3QaJS5jYXRwb2NzLnYxLlRlc3ROb3RpZmljYXRpb25zUmVzcG9uc2VCR1pFZ2l0aHViLmNvbS9jaXNjby1kY2xvdWQvY2F0LXBvY3Mtb3BlcmF0b3IvZ2VuL2dvL2NhdHBvY3MvdjE7Y2F0cG9jc3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * NotificationSettings contains notification configuration
 *
 * @generated from message catpocs.v1.NotificationSettings
 */
export type NotificationSettings = Message<"catpocs.v1.NotificationSettings"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: bool notify_on_deploy = 2;
   */
  notifyOnDeploy: boolean;

  /**
   * @generated from field: bool notify_on_failure = 3;
   */
  notifyOnFailure: boolean;

  /**
   * @generated from field: bool notify_on_sync = 4;
   */
  notifyOnSync: boolean;

  /**
   * @generated from field: string webex_room_id = 5;
   */
  webexRoomId: string;

  /**
   * @generated from field: bool webex_enabled = 6;
   */
  webexEnabled: boolean;

  /**
   * @generated from field: string email_recipients = 7;
   */
  emailRecipients: string;

  /**
   * @generated from field: bool email_enabled = 8;
   */
  emailEnabled: boolean;
};

/**
 * Describes the message catpocs.v1.NotificationSettings.
 * Use `create(NotificationSettingsSchema)` to create a new message.
 */
export const NotificationSettingsSchema: GenMessage<NotificationSettings> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 0);

/**
 * Settings represents all operator settings
 *
 * @generated from message catpocs.v1.Settings
 */
export type Settings = Message<"catpocs.v1.Settings"> & {
  /**
   * @generated from field: catpocs.v1.NotificationSettings notifications = 1;
   */
  notifications?: NotificationSettings;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.Settings.
 * Use `create(SettingsSchema)` to create a new message.
 */
export const SettingsSchema: GenMessage<Settings> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 1);

/**
 * GetSettingsRequest is the request message for GetSettings
 *
 * @generated from message catpocs.v1.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"catpocs.v1.GetSettingsRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 2);

/**
 * GetSettingsResponse is the response message for GetSettings
 *
 * @generated from message catpocs.v1.GetSettingsResponse
 */
export type GetSettingsResponse = Message<"catpocs.v1.GetSettingsResponse"> & {
  /**
   * @generated from field: catpocs.v1.Settings settings = 1;
   */
  settings?: Settings;
};

/**
 * Describes the message catpocs.v1.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema: GenMessage<GetSettingsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 3);

/**
 * UpdateSettingsRequest is the request message for UpdateSettings
 *
 * @generated from message catpocs.v1.UpdateSettingsRequest
 */
export type UpdateSettingsRequest = Message<"catpocs.v1.UpdateSettingsRequest"> & {
  /**
   * Notification settings
   *
   * @generated from field: catpocs.v1.NotificationSettings notifications = 1;
   */
  notifications?: NotificationSettings;
};

/**
 * Describes the message catpocs.v1.UpdateSettingsRequest.
 * Use `create(UpdateSettingsRequestSchema)` to create a new message.
 */
export const UpdateSettingsRequestSchema: GenMessage<UpdateSettingsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 4);

/**
 * UpdateSettingsResponse is the response message for UpdateSettings
 *
 * @generated from message catpocs.v1.UpdateSettingsResponse
 */
export type UpdateSettingsResponse = Message<"catpocs.v1.UpdateSettingsResponse"> & {
  /**
   * @generated from field: catpocs.v1.Settings settings = 1;
   */
  settings?: Settings;
};

/**
 * Describes the message catpocs.v1.UpdateSettingsResponse.
 * Use `create(UpdateSettingsResponseSchema)` to create a new message.
 */
export const UpdateSettingsResponseSchema: GenMessage<UpdateSettingsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 5);

/**
 * TestNotificationsRequest is the request message for TestNotifications
 *
 * @generated from message catpocs.v1.TestNotificationsRequest
 */
export type TestNotificationsRequest = Message<"catpocs.v1.TestNotificationsRequest"> & {
  /**
   * "webex" or "email"
   *
   * @generated from field: string channel = 1;
   */
  channel: string;
};

/**
 * Describes the message catpocs.v1.TestNotificationsRequest.
 * Use `create(TestNotificationsRequestSchema)` to create a new message.
 */
export const TestNotificationsRequestSchema: GenMessage<TestNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 6);

/**
 * TestNotificationsResponse is the response message for TestNotifications
 *
 * @generated from message catpocs.v1.TestNotificationsResponse
 */
export type TestNotificationsResponse = Message<"catpocs.v1.TestNotificationsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.TestNotificationsResponse.
 * Use `create(TestNotificationsResponseSchema)` to create a new message.
 */
export const TestNotificationsResponseSchema: GenMessage<TestNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_settings, 7);

/**
 * SettingsService manages operator settings
 *
 * @generated from service catpocs.v1.SettingsService
 */
export const SettingsService: GenService<{
  /**
   * GetSettings retrieves current settings
   *
   * @generated from rpc catpocs.v1.SettingsService.GetSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof GetSettingsRequestSchema;
    output: typeof GetSettingsResponseSchema;
  },
  /**
   * UpdateSettings updates operator settings
   *
   * @generated from rpc catpocs.v1.SettingsService.UpdateSettings
   */
  updateSettings: {
    methodKind: "unary";
    input: typeof UpdateSettingsRequestSchema;
    output: typeof UpdateSettingsResponseSchema;
  },
  /**
   * TestNotifications sends a test notification
   *
   * @generated from rpc catpocs.v1.SettingsService.TestNotifications
   */
  testNotifications: {
    methodKind: "unary";
    input: typeof TestNotificationsRequestSchema;
    output: typeof TestNotificationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_settings, 0);

